import { render, staticRenderFns } from "./InvitePage.vue?vue&type=template&id=58e74188&scoped=true"
import script from "./InvitePage.vue?vue&type=script&lang=js"
export * from "./InvitePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e74188",
  null
  
)

export default component.exports